module.exports = __webpack_public_path__ + "static/media/1.90de7e09.png";